export default __webpack_public_path__ + "static/media/netsuit.78af87ca.svg";